export default __webpack_public_path__ + "static/media/Salesforce.4871ea42.svg";